import { instanceWithAuth } from "@/api/index";

function checkPass(param) {
    return instanceWithAuth.post("/user/check-pass", param);
}
function getMyInfo() {
    return instanceWithAuth.get("/user/my-info");
}
function getCmpInfo() {
    return instanceWithAuth.get("/user/cmp-info");
}
function changeUserInfo(param) {
    return instanceWithAuth.post("/user/change-info", param);
}
function getUser() {
    return instanceWithAuth.get("/user/user");
}
function getMktAgree() {
    return instanceWithAuth.get("/user/mkt")
}
function changePromotions(param) {
    return instanceWithAuth.post("/user/promotion", param)
}
function changePw(param) {
    return instanceWithAuth.post("/user/passwd", param);
}
function getMemberList(param) {
    return instanceWithAuth.get("/user/members", { params: param });
}
function changeMemberGrade(param) {
    return instanceWithAuth.post("/user/member/grade", param);
}
function deleteUser() {
    return instanceWithAuth.post("/user/delete");
}
function deleteMember(param) {
    return instanceWithAuth.post("/user/member/delete", param)
}

export { checkPass, getMyInfo, getCmpInfo, changeUserInfo, getUser, getMktAgree, changePromotions, changePw, getMemberList, changeMemberGrade, deleteUser, deleteMember }